import { Share2 } from "lucide-preact";
import { useState } from "preact/hooks";
import { ShareModal } from "./ShareModal";

export type ShareButtonProps = {
  url: string;
  title: string;
  text?: string;
  class?: string;
  buttonLabel?: string;
  iconSize?: number;
  iconClass?: string;
  articleId?: string;
  authorAlias?: string;
};

const DEFAULT_CLASS = "absolute top-4 right-4 p-3 rounded-full bg-white/20 backdrop-blur-sm hover:bg-white/30 transition-colors";

export const ShareButton = ({
  url,
  title,
  text,
  class: className = DEFAULT_CLASS,
  buttonLabel = "Share article",
  iconSize = 20,
  iconClass = "text-white",
  articleId,
  authorAlias,
}: ShareButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button type="button" onClick={() => setIsOpen(true)} class={className} aria-label={buttonLabel}>
        <Share2 size={iconSize} class={iconClass} />
      </button>
      <ShareModal isOpen={isOpen} onClose={() => setIsOpen(false)} url={url} title={title} text={text} articleId={articleId} authorAlias={authorAlias} />
    </>
  );
};
